import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JsonResult } from '../core/json-result.model';
import { Financing } from '../models/financing.model';
import { PaymentSchedule } from '../models/payment-schedule.model';
import { CreditLine } from '../models/credit-line.model';
import { EnvironmentService } from '../core/services/environment.service';
import { CreditLineFNB } from 'src/app/models/account/credit-line-fnb.model';

@Injectable({
  providedIn: 'root'
})
export class FinancingService {
  private controller = 'Financing';
  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  listLastFinancings(clientCode: string): Observable<JsonResult<Financing[]>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}`;
    let params = new HttpParams();
    params = params.append("clientCode", clientCode)
    return this.httpClient.get<JsonResult<Financing[]>>(url, { params: params });
  }

  listPaymentSchedule(financingNumber: string): Observable<JsonResult<PaymentSchedule[]>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/ListPaymentSchedules`;
    let params = new HttpParams();
    params = params.append("financingNumber", financingNumber)
    return this.httpClient.get<JsonResult<PaymentSchedule[]>>(url, { params: params });
  }

  getCreditLine(clientCode: string): Observable<JsonResult<CreditLine>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/GetCreditLine`;
    let params = new HttpParams();
    params = params.append("clientCode", clientCode)
    return this.httpClient.get<JsonResult<CreditLine>>(url, { params: params });
  }

  download(financingNumber: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/DownloadPaymentSchedules`;
    let headers = new HttpHeaders();
    headers = headers.append("Accept", "application/pdf");
    let params = new HttpParams();
    params = params.append("financingNumber", financingNumber)
    return this.httpClient.get(url, { headers: headers, params: params, responseType: 'blob' });
  }

  download2(financing: Financing, paymentSchedule: PaymentSchedule[]) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/DownloadPaymentSchedules`;
    let headers = new HttpHeaders();
    headers = headers.append("Accept", "application/pdf");
    financing.paymentSchedule = paymentSchedule;
    /*let params = new HttpParams();
    params = params.append("financingNumber", financingNumber)
    this.httpClient.post<JsonResult<any>>(url, accountInsertRequest);*/
    return this.httpClient.post(url, financing, { headers: headers, responseType: 'blob' });
    
  }

  getCreditLineFNB(documentType: string, documentNumber: string): Observable<JsonResult<CreditLineFNB>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/GetCreditLineFNB/${documentType}/${documentNumber}`;
    return this.httpClient.get<JsonResult<CreditLineFNB>>(url);
  }
}
